<template>
  <div
    v-if="error"
    class="field__meta"
  >
    <span
      class="field__meta__help"
      v-text="error"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'ErrorMessage',
  props: {
    error: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>
